import _helper from "actions/helper";

const dt = {
    setup(price) {
        this.price = JSON.parse(JSON.stringify(price));
    },

    getParent(id, obj) {
        for (let it of obj.items) {
            if (it.id === id || it.tempId === id)
                return obj;
            if (it.items && it.items.length > 0) {
                let foundParent = this.getParent(id, it);
                if (foundParent) return foundParent;
            }
        }
    },

    getItem(id, obj) {
        for (let it of obj.items) {
            if (it.id === id || it.tempId === id)
                return it;
            if (it.items && it.items.length > 0) {
                let foundItem = this.getParent(id, it);
                if (foundItem) return foundItem;
            }
        }
    },

    copyItem(id) {
        const parentItem = this.getParent(id, this.price[0]);
        const index = parentItem.items.findIndex(it => it.id === id || it.tempId === id);
        const tempId = _helper.number.generateUniqueID();
        const copiedObj = { ...parentItem.items[index] };
        delete copiedObj.id;
        copiedObj.name += " copy";
        copiedObj.tempId = tempId;
        parentItem.items.splice(index + 1, 0, copiedObj);
        return this.price[0];
    },

    deleteItem(id) {
        const parentItem = this.getParent(id, this.price[0]);
        parentItem.items = parentItem.items.filter(it => it.id !== id && it.tempId !== id);
        return this.price[0];
    },

    moveRows(id1, id2, id) {
        const parentItem = this.getParent(id, this.price[0]);
        const itemToMove = parentItem.items.splice(id1, 1)[0];
        parentItem.items.splice(id2, 0, itemToMove);
        return this.price[0];
    },

    changeDataRow(altCode, name, value, id) {
        const parentItem = this.getParent(id, this.price[0]);
        const index = parentItem.items.findIndex(it => it.id === id || it.tempId === id);

        if (altCode)
            parentItem.items[index].altCode = altCode;
        if (name)
            parentItem.items[index].name = name;
        if (value !== undefined)
            parentItem.items[index].value = value;

        return this.price[0];
    },

    convertGroup(id) {
        const parentItem = this.getParent(id, this.price[0]);
        const index = parentItem.items.findIndex(it => it.id === id || it.tempId === id);
        parentItem.items[index].isGroup = true;
        return this.price[0];
    },

    getPrice() {
        return this.price;
    },

    addSection(section) {
        this.price[0].items.push(section);
        return this.price[0];
    },

    changeNameSection(section) {
        const id = section.id || section.tempId;
        const item = this.getItem(id, this.price[0]);
        item.name = section.name;
        return this.price[0];
    },

    addPriceItems(items) {
        const parentId = items[0].parentId ?? items[0].tempParentId;
        const parent = this.getItem(parentId, this.price[0]);
        parent.items = [...parent.items, ...items];
        return this.price[0];
    }

};

export default dt;
